// check if any of the object's string like values contain the substring (case insensitive)
export default function(obj, fields, query) {
  for (const field of fields) {
    const value = field.split('.').reduce((o, i) => (o || {})[i], obj); // allow for dotted fields user.email etc
    const normalized = String(value || '').toLowerCase();
    if (normalized.indexOf(query.toLowerCase()) !== -1) {
      return true;
    }
  }
  return false;
}
